<div class="spinner-container" *ngIf="display">
  <ngx-spinner
    [bdColor]="backgroundTransparent ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,.2)'"
    [fullScreen]="fullscreen"
    type="ball-scale-multiple"
    template="<img src='/assets/img/isupplier_spinner.gif' style='width: 100px; height: auto;' />">
  </ngx-spinner>
</div>
